/**
 * Consent-Abfragen gegen das SSO: offene Rechtsdokument-Zustimmungen
 * (AGB, Datenschutz, Nutzungsvereinbarung) des eingeloggten Nutzers laden,
 * Dokumente einsehen und Zustimmungen protokollieren.
 * Genutzt vom ConsentGate (blockierender Dialog nach Login).
 */
import tokenService from './tokenService';

const SSO_URL = process.env.REACT_APP_SSO_URL || 'http://localhost:9000';

export interface PendingConsent {
    documentTitle: string;
    slug: string;
    versionUuid: string;
    version: number;
    publishedAt: string;
    fileName: string;
}

function authHeaders(): Record<string, string> {
    return { Authorization: `Bearer ${tokenService.getToken()}` };
}

export async function getPendingConsents(): Promise<PendingConsent[]> {
    const response = await fetch(`${SSO_URL}/api/consent/pending`, { headers: authHeaders() });
    if (!response.ok) {
        throw new Error(`Offene Zustimmungen konnten nicht geladen werden (${response.status})`);
    }
    const data = await response.json();
    return data.pending;
}

export async function consentToVersion(versionUuid: string): Promise<void> {
    const response = await fetch(`${SSO_URL}/api/consent/${versionUuid}`, {
        method: 'POST',
        headers: authHeaders(),
    });
    if (!response.ok) {
        const data = await response.json().catch(() => ({}));
        throw new Error(data.error || `Zustimmung fehlgeschlagen (${response.status})`);
    }
}

export async function downloadDocumentVersion(versionUuid: string, fileName: string): Promise<void> {
    const response = await fetch(`${SSO_URL}/api/global-document-versions/${versionUuid}/download`, {
        headers: authHeaders(),
    });
    if (!response.ok) {
        throw new Error(`Download fehlgeschlagen (${response.status})`);
    }
    const blob = await response.blob();
    const objectUrl = URL.createObjectURL(blob);
    const anchor = document.createElement('a');
    anchor.href = objectUrl;
    anchor.download = fileName;
    document.body.appendChild(anchor);
    anchor.click();
    anchor.remove();
    URL.revokeObjectURL(objectUrl);
}
